import { defineComponent as a, openBlock as t, createElementBlock as i, normalizeClass as l, createVNode as o, unref as r, withCtx as u, createTextVNode as s, toDisplayString as n, createCommentVNode as d } from "vue";
import "./ghl-ui.es13.js";
import { FixedUnit as c } from "./ghl-ui.es239.js";
import "./ghl-ui.es740.js";
import g from "./ghl-ui.es118.js";
const m = {
  key: 0,
  class: "ghl-spacing__trigger-unit"
}, p = a({
  __name: "Trigger",
  props: {
    isValid: {
      type: Boolean,
      defaultValue: !0
    },
    value: {
      type: String,
      required: !0
    },
    unit: {
      type: String,
      required: !0
    },
    positionType: {
      type: String,
      required: !0
    },
    readonly: Boolean
  },
  setup(e) {
    return (y, f) => (t(), i("div", {
      class: l([
        "ghl-spacing__trigger",
        e.isValid ? "" : "invalid",
        ["left", "right"].includes(e.positionType) ? "under" : "aside",
        e.readonly ? "read-only" : ""
      ])
    }, [
      o(r(g), { class: "ghl-spacing__trigger-value" }, {
        default: u(() => [
          s(n(e.value ?? "-"), 1)
        ]),
        _: 1
      }),
      Object.values(r(c)).includes(e.unit) ? d("", !0) : (t(), i("span", m, n(e.unit), 1))
    ], 2));
  }
}), S = p;
export {
  S as default
};
